import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CATEGORIES = [
  { id: 'all', label: 'All' },
  { id: 'General', label: 'General' },
  { id: 'Landing Page', label: 'Landing' },
  { id: 'BI/Analytics', label: 'BI' },
];

export default function StyleExplorer({ selectedStyle, onSelect }) {
  const [styles, setStyles] = useState([]);
  const [category, setCategory] = useState('all');
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/magic/styles`).then(r => setStyles(r.data)).catch(() => {});
  }, []);

  const filtered = styles.filter(s => {
    if (category !== 'all' && s.type !== category) return false;
    if (search) {
      const q = search.toLowerCase();
      return s.name.toLowerCase().includes(q) || s.keywords.toLowerCase().includes(q) || s.best_for.toLowerCase().includes(q);
    }
    return true;
  });

  const cleanName = (name) => name.replace(/\s*\(.*?\)\s*$/, '');

  return (
    <div className="flex flex-col flex-1 min-h-0">
      {/* Category filter + search */}
      <div className="space-y-2 mb-3 shrink-0">
        <div className="flex items-center gap-1 flex-wrap">
          {CATEGORIES.map(cat => (
            <button key={cat.id} onClick={() => setCategory(cat.id)}
              className={`px-2.5 py-1 rounded-full text-[10px] transition-colors ${
                category === cat.id
                  ? 'bg-[var(--orbis-blue)] text-[var(--orbis-bg)] font-medium'
                  : 'text-[var(--orbis-t4)] border border-[var(--orbis-s2)] hover:border-[var(--orbis-s3)]'
              }`}
            >{cat.label}</button>
          ))}
        </div>
        <input
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search styles..."
          className="w-full h-7 px-3 text-[11px] bg-[var(--orbis-bg)] border border-[var(--orbis-s2)] rounded-lg text-[var(--orbis-t1)] placeholder-[var(--orbis-s3)] outline-none focus:border-[var(--orbis-s3)]"
        />
      </div>

      {/* Style cards — scrollable, fills remaining space */}
      <div className="flex-1 overflow-y-auto -mr-1 pr-1">
        <div className="grid grid-cols-2 gap-2">
          {filtered.map(s => {
            const isSelected = selectedStyle?.toLowerCase() === s.name?.toLowerCase() || selectedStyle?.toLowerCase()?.includes(cleanName(s.name).toLowerCase());
            const name = cleanName(s.name);
            return (
              <button key={s.name} onClick={() => onSelect(s.name)}
                className={`text-left p-3 rounded-xl border transition-all duration-150 ${
                  isSelected
                    ? 'bg-[var(--orbis-s2)] border-[#B8CCDF40] ring-1 ring-[#B8CCDF30]'
                    : 'bg-[var(--orbis-s1)] border-[var(--orbis-s2)] hover:border-[var(--orbis-s3)]'
                }`}
              >
                <span className="text-[12px] font-medium text-[var(--orbis-t1)] block truncate">{name}</span>
                {s.effects && (
                  <p className="text-[10px] text-[var(--orbis-t4)] mt-1 leading-relaxed line-clamp-2">{s.effects}</p>
                )}
              </button>
            );
          })}
        </div>
        <p className="text-[9px] text-[var(--orbis-s3)] font-mono mt-2">{filtered.length} styles</p>
      </div>
    </div>
  );
}
